<template>
  <div class="icon-service-ux">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 130 130"
      xmlns="http://www.w3.org/2000/svg"
    >

      <g
        stroke="#FFF"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
      >
        <!-- eslint-disable max-len -->

        <path
          d="M96.91 108.802C110.887 98.83 120 82.48 120 64c0-30.376-24.624-55-55-55S10 33.624 10 64c0 23.216 14.385 43.073 34.728 51.143"
          stroke-dasharray="290.82 290.82"
          stroke-dashoffset="290.82"
        />

        <path
          d="M55.643 52.214h51.011M95.886 63.785l10.9-10.899-10.9-10.873M79.656 69.43c-1.652.602-2.413 1.392-3.091 2.845l-1.008-2.77c-1.173-3.222-5.265-4.527-8.496-3.351-1.701.619-2.983 1.512-3.633 3.06-1.478-2.571-4.623-3.399-7.51-2.348-1.652.601-2.988 1.788-3.654 3.275l-4.68-12.856c-1.173-3.222-4.978-5.061-8.209-3.885-3.231 1.176-4.965 5.031-3.792 8.253L46.48 91.59c-5.57 2.035-7.419 8.93-4.89 15.88l.49 1.345c2.391 6.569 8.576 17.763 23.13 18.919 3.659.29 7.191-.753 10.61-1.762a67.724 67.724 0 0 0 4.002-1.305c3.87-1.408 8.048-3.437 11.443-6.652 6.002-5.681 7.57-14.424 4.201-23.378l-7.892-21.684c-1.136-3.118-4.687-4.698-7.917-3.522zM67.796 81.217l-4.704-12.925M79.42 80.122l-3.695-10.155M56.969 83.066l-5.713-15.694M50.007 101.283l-5.712-15.695"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="379.21 379.21"
          stroke-dashoffset="379.21"
        />

        <path
          d="M51.079 55.852c.366-1.159.564-2.393.564-3.673C51.643 45.453 46.19 40 39.464 40s-12.178 5.453-12.178 12.179a12.16 12.16 0 0 0 4.86 9.735"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="53.28 53.28"
          stroke-dashoffset="53.28"
        />
        <!-- eslint-enable max-len -->
      </g>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconServiceUx'
};
</script>

<style lang="scss" src="@/assets/icons/icon-service-ux-view.scss"></style>



// WEBPACK FOOTER //
// icon-service-ux-view.vue